import React, {useEffect} from 'react';
import {Link} from 'react-router-dom'
import {Loading} from '../custom/LoadingComponent'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DataGrid } from '@mui/x-data-grid';
import Container from '@mui/material/Container';

import * as SelectListData from '../constants/CustomSelectData';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import * as TypeConvertor from '../util/TypeConvertor';


function Clients(props) {
    console.log("___ Clients ___");

    useEffect(() => {
        props.loadComponentData();
    }, []);

    const columns = [
        {
            field: 'clientName',
            headerName: 'Nume',
            width: 350,
            valueGetter: (params) => params.row.generalSection.clientName,
            renderCell: (params) => {
                return(
                    <Link to={`/clients/${params.row.id}`}>
                        {params.row.generalSection.clientName}
                    </Link>
                );
            }
        },
        {
            field: 'client-type',
            headerName: 'Tip Client',
            width: 150,
            valueGetter: (params) => TypeConvertor.getClientTypeName(params.row.generalSection.clientType)
        },
        {
            field: 'rsvtiServiceType',
            headerName: 'Serviciu RSVTI',
            width: 150,
            valueGetter: (params) => TypeConvertor.getClientServiceTypeName(params.row.generalSection.rsvtiServiceType)
        }
    ];

    if(props.clients.status === ReduxDataStatus.IDLE || 
       props.clients.status === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else { 
        return(
            <React.Fragment>
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Clienti</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <h3>Clienti</h3>
                            <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                <Link to={'/clients/newclient'}>
                                    <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Client</Button>
                                </Link>
                            </Box>
                        </Box>                
                    </Box>
                    <hr />

                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        <DataGrid
                            rows={props.clients.clients}
                            columns={columns}
                            initialState={{
                                sorting: { sortModel: [{ field: 'clientName', sort: 'asc' }] }
                            }}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box>
                </Stack>

            </Box>
            </Container>
            </React.Fragment>
        );
    }
    
}

export default Clients;